export default __webpack_public_path__ + "static/media/love.614d09f2.svg";